// extracted by mini-css-extract-plugin
module.exports = {"settingsCard":"OnboardingSettings_settingsCard__xTD55","title":"OnboardingSettings_title__1DfhY"};